import { FormItem } from '@framework/form';
import { Collapse, Space } from 'antd';
import { useWatch } from 'react-hook-form';
import { useTreeReferencesContext } from '../../../../tree/references';
import { StyledDrawerCollapse } from '../../../../ui/drawer';
import { SimilInputSpan } from '../../../../ui/form/SimilInputSpan';
import { IExpression } from '../../../expressions/IExpression';
import {
  FieldDatatype,
  isObjectsArrayField,
  isSameFieldDatatype,
} from '../../../expressions/datatype/Datatype';
import { isExpressionReferenceOfObjectsArray } from '../../../expressions/datatype/isExpressionReferenceOfObjectsArray';
import { ExpressionReferenceInput } from '../../../expressions/references/input/ExpressionReferenceInput';
import {
  AssignableExpressionInput,
  IAssignableExpressionAllowsReference,
} from '../../../expressions/repository/assignable/input/AssignableExpressionInput';
import { WidgetRepository } from '../WidgetRepository';
const { Panel } = Collapse;

export interface IDefaultValueInputProps {
  /**
   * Permette di personalizzare il filtro sulle reference selezionabili.
   */
  allowsReferences?: IAssignableExpressionAllowsReference;
  /**
   * Se fornito, permette di controllare il fieldDataType da utilizzare.
   * Altrimenti, viene estratto automaticamente dal widget type.
   */
  forceFieldDataType?: FieldDatatype;
}

export function DefaultValueInput(props: IDefaultValueInputProps) {
  const { references, widget } = useTreeReferencesContext();
  const field =
    props.forceFieldDataType ??
    WidgetRepository.find(widget?.type)?.getReference?.([], widget!)?.field;

  const childReferences =
    field && isObjectsArrayField(field) ? field.structure : [];

  const defaultValue: IExpression | null = useWatch({ name: 'defaultValue' });

  if (!field) return null;

  return (
    <>
      <FormItem name="defaultValue" label="Valore di default">
        <AssignableExpressionInput
          size="large"
          block
          // Rimuovo la reference a sé stesso (non ha senso avere un valore di default che fa riferimento a se stesso)
          references={references.filter(r => r.id !== widget?.id)}
          name="defaultValue"
          field={field}
          allowsReference={props.allowsReferences}
        />
      </FormItem>

      {field && isExpressionReferenceOfObjectsArray(defaultValue) && (
        <StyledDrawerCollapse defaultActiveKey={['list-default']} ghost>
          <Panel
            header="Valori di default per gli elementi della lista"
            key="list-default"
          >
            {defaultValue.value.field.structure.map((child, index) => (
              <div key={`${child.id}`} style={{ marginBottom: 8 }}>
                <FormItem
                  key={`${child.id}`}
                  name={`defaultValueChildren[${index}]`}
                  layout={{ removeMargin: true }}
                >
                  <Space.Compact block>
                    <SimilInputSpan>{child.label}</SimilInputSpan>
                    <ExpressionReferenceInput
                      width="100%"
                      allowClear
                      name={`defaultValueChildren[${index}]`}
                      references={childReferences.filter(r =>
                        isSameFieldDatatype(child.field, r.field),
                      )}
                    />
                  </Space.Compact>
                </FormItem>
              </div>
            ))}
          </Panel>
        </StyledDrawerCollapse>
      )}
    </>
  );
}
